export const STORAGE = {
  TOKEN: 'token',
  LOCALE: 'sv',
  PERMISSIONS: 'permissions',
  ADMIN_MODE: "admin_mode"
};

export const SUPPORTED_LANGUAGES = ['en', 'sv'];
